// extracted by mini-css-extract-plugin
export default {"wrap":"rs-z","fullWidth":"ss-z","items":"ts-z","featureCss":"us-z","disabled":"vs-z","imgCss":"ws-z"};